import { render, staticRenderFns } from "./ActiveTask.vue?vue&type=template&id=406da512&"
import script from "./ActiveTask.vue?vue&type=script&lang=js&"
export * from "./ActiveTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports